module.exports = __webpack_public_path__ + "static/media/booty.325e3085.svg";